import { PurchaseProductDetailsVariant } from '@ancon/wildcat-types'

/**
 * Resolves the currency of the product being configured, from the selected
 * variant or else the main product variant. Ingredients have no currency of
 * their own in the API, so this is also the currency to show them in.
 */
export default function getProductDetailsCurrency(
  variants: PurchaseProductDetailsVariant[] | undefined,
  selectedVariant?: PurchaseProductDetailsVariant | null,
) {
  const mainProductVariant = variants?.find(v => v.isMainProductVariant)

  return (
    selectedVariant?.variantPrice.unitPriceCurrency ??
    mainProductVariant?.variantPrice.unitPriceCurrency
  )
}
